export default "__VITE_ASSET__BIDbPsxq__"